import React from 'react';
import { Create } from 'react-admin';
import EstadoForm from '../EstadoForm';

function EstadoCreate(props) {
  return (
    <Create {...props}>
      <EstadoForm redirect="list" />
    </Create>
  );
}

export default EstadoCreate;
